import { productMetafieldKnowledgeSchema } from "@redotech/shopper-agent-knowledge-common/product-metafield-view";
import * as z from "zod";

/** The metafields the agent reads on every product, with their guidance. */
export const listProductMetafieldKnowledge = {
  name: "listProductMetafieldKnowledge" as const,
  input: z.object({}),
  output: z.object({ entries: z.array(productMetafieldKnowledgeSchema) }),
};
